export const getSpinnerColors = (
  color: string
): [string, string, string, string, string] => {
  return [color, color, color, color, color];
};
